'use client'
// O CSS do Font Awesome vem no build pelo globals.css: sem isto ele também era injetado por JavaScript e os ícones
// apareciam gigantes até a página rodar. Fica aqui porque este módulo roda no servidor e no navegador antes de qualquer
// ícone.
import { config } from '@fortawesome/fontawesome-svg-core'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useEffect } from 'react'
import { ToastContainer } from 'react-toastify'
import Loader from '@/components/Layout/Loader'
import { getQueryClient } from '@/lib/queryClient'
import { removeLegacyStorage } from '@/stores/legacyStorage'

config.autoAddCss = false

const isDebugToolsEnabled = process.env.NEXT_PUBLIC_ENABLE_DEBUG_TOOLS === 'true'

/** Único provider global da loja (padrão do orbit): React Query, toasts e o overlay de carregamento. */
export const AppProvider = ({ children }: { children: React.ReactNode }) => {
    const queryClient = getQueryClient()

    // Chaves de stores que saíram da loja, ainda no navegador de quem já a usava.
    useEffect(removeLegacyStorage, [])

    return (
        <QueryClientProvider client={queryClient}>
            <ToastContainer position="top-center" />
            <Loader />
            {children}
            {isDebugToolsEnabled && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
    )
}
